import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import type { AxiosResponse } from 'axios';
import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared/lib';
import { QUERIES_INFO, MUTATIONS_INFO } from '@shared/lib/const';
type TUseDeimpersonateResponse = {
  message: string;
  status: string;
};
export type TUseDeimpersonateParams = {
  options?: UseMutationOptions<AxiosResponse<TUseDeimpersonateResponse>, unknown, void>;
};
export const useDeimpersonate = ({
  options
}: TUseDeimpersonateParams = {}) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<TUseDeimpersonateResponse>, TAxiosError, void>(() => axiosInstance.post<TUseDeimpersonateResponse, AxiosResponse<TUseDeimpersonateResponse>, void>(MUTATIONS_INFO.deimpersonation), {
    ...options,
    onSuccess: async () => {
      queryClient.invalidateQueries(QUERIES_INFO.currentUser.key);
    }
  });
};